module.exports = __webpack_public_path__ + "static/media/NASA_Worm_logo.dc42517b.svg";